const defaultMobilePaymentFormState = {
  name: "",
  address: "",
  locality: "",
  apartment: "",
  stateId: "",
  countryAlpha2: "",
  countryId: "",
  postal: "",
  voucher: "",
  deliveryMethod: "",
  user_id: "",
  plan_id: "",
  headsetType: "regular",
  headset_purchase_token: "",
  phoneNumber: "",
  itemType: "Plan",
};

const mobilePaymentFields = [
  "name",
  "address",
  "locality",
  "apartment",
  "stateId",
  "countryAlpha2",
  "countryId",
  "postal",
  "voucher",
  "deliveryMethod",
  "user_id",
  "headset_purchase_token",
  "headsetType",
  "plan_id",
  "phoneNumber",
  "itemType",
];

export { defaultMobilePaymentFormState, mobilePaymentFields };
